import { updateView } from '../../current-view/actions/updateView';
import { THREAD_VIEW } from '../../current-view/constants/views';
import { getOriginViewContext } from '../../kb-article/kbArticleSelectors';
import { selectThread } from '../../selected-thread/actions/selectThread';
import { setStandardWidgetSize } from '../../widget-size/widgetSizeSlice';
// @ts-expect-error untyped module
import { getCurrentThreadId } from '../../thread-history/selectors/getCurrentThreadId';
import { updateIsOnSearchMode } from '../../visitor-widget/reducers/isOnSearchMode';
import { getIsUngatedForKBInWidget } from '../../widget-data/selectors/widgetDataSelectors';
export function restorePreviousViewFromKBArticle() {
  return (dispatch, getState) => {
    const {
      view: originView,
      lastSearchModeEnabled
    } = getOriginViewContext(getState());
    if (getIsUngatedForKBInWidget(getState()) && lastSearchModeEnabled) {
      dispatch(updateIsOnSearchMode(true));
    }
    dispatch(setStandardWidgetSize());
    if (originView === THREAD_VIEW) {
      dispatch(selectThread(getCurrentThreadId(getState())));
    }
    dispatch(updateView(originView));
  };
}